import request from '@/utils/request'

// 询价说明主表信息，参数pcInfoId
export function searchSubjectInfo(query) {
  return request({
    url: '/api/srm-slcm/pmPriceCompSubject/searchSubjectInfo',
    method: 'get',
    params: query
  })
}

// 获取投标单位,参数：pcInfoId
export function searchPriceCompSupp(query) {
  return request({
    url: '/api/srm-slcm/pmPriceCompSupp/searchPriceCompSupp',
    method: 'get',
    params: query
  })
}

// 报价须知，参数：pcInfoId
export function selectPriceCompNoticeById(obj) {
  return request({
    url: '/api/srm-slcm/pmPriceCompNotice/selectPriceCompNoticeById',
    method: 'post',
    data: obj
  })
}

// 获取招标文件
export function selectPriceCompDocList(createHeadId) {
  return request({
    url: `/api/srm-slcm/pmPriceCompDoc/selectPriceCompDocList/${createHeadId}`,
    method: 'get'
  })
}

// 评定人员选择
export function getJudgePersion(createHeadId) {
  return request({
    url: `/api/srm-slcm/pmPriceCompJudge/getJudgePersion/${createHeadId}`,
    method: 'get'
  })
}

// 图纸附件需要先从PLM上获取下载对应的key
export function getAttachmentFileUrl(obj) {
  return request({
    url: '/api/srm-slcm/pmUnpricedOrder/download',
    method: 'post',
    data: obj
  })
}

// 获取图纸附件列表
export function queryMatFile(obj) {
  return request({
    url: '/api/srm-transfer/transfer/queryMatFile',
    method: 'post',
    data: obj
  })
}
